<template>
    <div class="w-100">жүктелнуде . . . </div>   
</template>
<script>
    import axios from 'axios';
    import {mapActions} from 'vuex';
    import {apiDomain,getHeader} from "../config/config";
    export default {
        name:"Auth",
        methods:{
            ...mapActions([
                'setLoginedUser'
            ]),
            getLoginedUser(result){
                    //alert(JSON.stringify(result));
                    window.localStorage.setItem("loginedUser",JSON.stringify(result));
                    //alert("mina hota "+ window.localStorage.getItem("loginedUser"));
                    this.setLoginedUser();
                    const ALLOWED = ['ADMIN', 'MANAGER', 'OPERATOR', 'MLRO', 'COMPILANCE']
                    result.userRoles.forEach(r => {
                        if (r && ALLOWED.includes(r.name)) {
                            window.location.href = "/#/users";
                        }
                    });
                // axios.get(apiDomain+'/logineduser',{headers:getHeader()})
                // .then(response=>{
                //     alert(JSON.stringify(response.data));
                //     //alert("gol yum maani hezee ireheer bna ");
                //     //state.loginedUser=response.data;
                //      window.localStorage.setItem("loginedUser",JSON.stringify(response.data));
                //      //alert("mina hota "+ window.localStorage.getItem("loginedUser"));
                //      this.setLoginedUser();
                //      result.roles.forEach(r => {
                //         if(r.roleName=='admin'){
                //             //this.$router.push({name:'Deliveries'});
                //             window.location.href = "/#/users";         
                //             return;
                //         }
                //     });
                // })
                // .catch(error => {
                //     //console.log(error.message)
                //     this.$bvToast.toast(error.message, {
                //         title: 'алдаа',
                //         autoHideDelay: 5000
                //     })
                // })   
            }
        },
        created(){
            let promise = axios.get(apiDomain+'/logineduser',{headers:getHeader()});
            return promise.then((response) => {
                const result = response.data;
                this.getLoginedUser(result);
                //alert(JSON.stringify(result));
               
            }).catch(error => {
                this.$router.push({name:'Login'});
            });
        }
    }
</script>